<script lang="ts">
import { defineComponent, inject } from "vue";
import FerienhausAnfrageService from "@/businesslogic/services/FerienhausAnfrageService";
import Logger from "js-logger";
import router from "@/router";
import { useFormStore } from "@/businesslogic/stores/formStore";

export default defineComponent({
  name: "BuendelDownloadLinks",
  props: {
    antrag: {
      type: Boolean,
      default: false,
    },
    trackingZusatz: String,
  },
  setup(props) {
    const piniaStore = useFormStore();
    const zeigeSpinner: any = inject("zeigeSpinner");

    async function herunterladenFHK(produktId: string) {
      zeigeSpinner.value = true;
      FerienhausAnfrageService.herunterladenFHK(
        piniaStore.getSessionToken(piniaStore.state),
        piniaStore.state,
        props.antrag,
        "EmailOderHerunterladen",
        props.trackingZusatz,
        produktId,
      )
        .then((res) => {
          if (res.status != 200) {
            throw new Error(res.statusText);
          }
          return res.data;
        })
        .then((data) => {
          Logger.debug("data ", data);
          piniaStore.state.id = data.id;
          piniaStore.state.status = data.status;
          piniaStore.state.anfrageNummer = data.anfrageNummer;
          const fileLink = document.createElement("a");
          fileLink.href = "data:application/pdf;base64," + data.korrespondenz.vorschlagDokument;
          fileLink.setAttribute("download", data.korrespondenz.dokumentName);
          document.body.appendChild(fileLink);

          if (piniaStore.state.isMakler) {
            piniaStore.state.adresseFelderSchrittDreiDeaktivieren = true;
          }
          zeigeSpinner.value = false;
          fileLink.click();
        })
        .catch(() => {
          zeigeSpinner.value = false;
          router.push("/fehler");
        });
    }

    function vgv_runterladen() {
      herunterladenFHK(piniaStore.state.ferienhaus.vgv.tarifinformationen.produktId);
    }

    function vhv_runterladen() {
      herunterladenFHK(piniaStore.state.ferienhaus.vhv.tarifinformationen.produktId);
    }

    function hug_runterladen() {
      herunterladenFHK(piniaStore.state.ferienhaus.hug.tarifinformationen.produktId);
    }

    function getAntragOderVorschlag() {
      return props.antrag ? "Antrag" : "Vorschlag";
    }

    return {
      props,
      piniaStore,
      vgv_runterladen,
      vhv_runterladen,
      hug_runterladen,
      getAntragOderVorschlag,
    };
  },
});
</script>

<template>
  <div>
    <ul>
      <li
        v-if="
          piniaStore.state.ferienhaus.versicherungsumfang === '0001' ||
          piniaStore.state.ferienhaus.versicherungsumfang === '0002'
        "
      >
        <a @click.prevent="vgv_runterladen">
          {{ getAntragOderVorschlag() }} Wohngebäudeversicherung als PDF herunterladen</a
        >
      </li>
      <li
        v-if="
          piniaStore.state.ferienhaus.versicherungsumfang === '0001' ||
          piniaStore.state.ferienhaus.versicherungsumfang === '0003'
        "
      >
        <a @click.prevent="vhv_runterladen">{{ getAntragOderVorschlag() }} Hausratversicherung als PDF herunterladen</a>
      </li>
      <li v-if="piniaStore.state.tarifinformationen.hausundgrundbesitzerhaftpflicht">
        <a @click.prevent="hug_runterladen"
          >{{ getAntragOderVorschlag() }} Haus- und Grundbesitzerhaftpflicht als PDF herunterladen</a
        >
      </li>
    </ul>
  </div>
</template>
